/** Mobile top bar + bottom tab bar — keep in sync with BottomNavigationStyles. */
export const MOBILE_BOTTOM_NAV_MQL = '(max-width: 800px)';

/**
 * Floating listing-detail hero chrome + site-header hide range.
 * Matches Theme `influencerSidebar` (751): chrome below 751px, site Header from 751px up.
 */
export const MARKETPLACE_DETAIL_HERO_CHROME_MQL = '(max-width: 750px)';

const MARKETPLACE_DETAIL_PATH_PATTERN = /^\/marketplace\/(influencers\/[^/]+(\/invite)?|campaigns\/[^/]+)$/;

const INFLUENCER_INVITE_PATH_PATTERN = /^\/marketplace\/influencers\/.+\/invite$/;

const INFLUENCER_DETAIL_PATH_PATTERN = /^\/marketplace\/influencers\/(?:(?:[^/]+\/dp\/[^/]+|dp\/[^/]+)|[^/]+)$/;

const BRAND_DETAIL_PATH_PATTERN = /^\/marketplace\/brands\/(?:(?:[^/]+\/dp\/[^/]+|dp\/[^/]+)|[^/]+)$/;

const CAMPAIGN_DETAIL_PATH_PATTERN = /^\/marketplace\/campaigns\/(?:(?:[^/]+\/dp\/[^/]+|dp\/[^/]+)|[^/]+)$/;

/** Brand invite details live outside /dashboard (e.g. /influencers/.../campaign/.../invite/...). */
const BRAND_INVITE_DETAILS_PATH_PATTERN = (
  /^\/influencers\/(?:[^/]+\/dp\/[^/]+\/campaign\/[^/]+(?:\/invite\/[^/]+)?|dp\/[^/]+\/campaign\/[^/]+(?:\/invite\/[^/]+)?|[^/]+)(?:\/|$)/
);

const COLLABORATION_JOURNEY_PATH_PATTERNS = [
  /^\/collaborations\/(?:[^/]+\/)?(?:dp\/[^/]+\/)?status(?:\/|$)/,
  /^\/dashboard\/collaboration(?:\/|$)/,
  /^\/dashboard\/collaborations\/(?:[^/]+\/)?(?:dp\/[^/]+\/)?invite-status(?:\/|$)/,
  /^\/dashboard\/collaboration-journey(?:\/|$)/,
  /^\/dashboard\/collaboration-status\/[^/]+(?:\/|$)/,
  /^\/dashboard\/applications\/[^/]+\/status(?:\/|$)/,
];

const BOTTOM_NAV_EXCLUDE_ROUTES = [
  '/login',
  '/signup',
  '/sign-up',
  '/mfa-verification',
  '/forgot-password',
  '/reset-password',
  '/brand-onboarding',
  '/influencer-onboarding',
];

export const isCollaborationJourneyRoute = (pathname) => (
  COLLABORATION_JOURNEY_PATH_PATTERNS.some((pattern) => pattern.test(pathname))
);

export const isBrandInviteDetailsRoute = (pathname) => (
  BRAND_INVITE_DETAILS_PATH_PATTERN.test(pathname)
);

export const isInfluencerDetailRoute = (pathname) => (
  INFLUENCER_DETAIL_PATH_PATTERN.test(pathname)
);

export const isCampaignDetailRoute = (pathname) => (
  CAMPAIGN_DETAIL_PATH_PATTERN.test(pathname)
);

export const isBrandDetailRoute = (pathname) => (
  BRAND_DETAIL_PATH_PATTERN.test(pathname)
);

/** Listing details use floating hero chrome instead of the site header (below 751px). */
export const shouldHideSiteHeaderOnMobile = (pathname) => (
  isInfluencerDetailRoute(pathname)
  || isCampaignDetailRoute(pathname)
  || isBrandDetailRoute(pathname)
);

export const isMarketplaceDetailRoute = (pathname) => (
  MARKETPLACE_DETAIL_PATH_PATTERN.test(pathname)
  || INFLUENCER_INVITE_PATH_PATTERN.test(pathname)
  || isInfluencerDetailRoute(pathname)
  || BRAND_DETAIL_PATH_PATTERN.test(pathname)
  || isCampaignDetailRoute(pathname)
);

/**
 * Mirrors BottomNavigation `showBottomNav` — true when the mobile tab bar renders.
 */
export function shouldShowBottomNavigation({
  pathname,
  isAuthenticated = false,
  userType = null,
}) {
  if (BOTTOM_NAV_EXCLUDE_ROUTES.includes(pathname)) return false;
  if (userType === 'admin' || pathname.startsWith('/admin')) return false;
  if (pathname.startsWith('/reset-password/')) return false;
  if (pathname.startsWith('/dashboard')) return false;
  if (isCollaborationJourneyRoute(pathname)) return false;
  if (isBrandInviteDetailsRoute(pathname)) return false;
  if (INFLUENCER_INVITE_PATH_PATTERN.test(pathname)) return false;
  if (isInfluencerDetailRoute(pathname)) return false;
  if (isBrandDetailRoute(pathname)) return false;
  if (isCampaignDetailRoute(pathname)) return false;
  if (isAuthenticated && !userType) return false;
  return true;
}

/**
 * True when the fixed mobile brand bar (logo row) should render.
 */
export function shouldShowMobileBrandBar({
  pathname,
  isAuthenticated = false,
  userType = null,
}) {
  if (!shouldShowBottomNavigation({ pathname, isAuthenticated, userType })) {
    return false;
  }
  return !isMarketplaceDetailRoute(pathname);
}
